import React from 'react';

export default function DuyuruTitle(data) {
  return (
    <h4>{data.Baslik}/{data.YayinAdi}</h4>
  );
}
